import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';
import LoadingSpinner from '../components/shared/LoadingSpinner';
import { resolveNextStepUrl } from './nextStep';

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const { requireEmailVerification, isLoading: isSettingsLoading } = useSettings();

  if (isLoading || isSettingsLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si l'admin a désactivé la vérification email, on traite verify-email
  // comme déjà fait (un nextStep 'verify-email' devient un passage direct
  // à l'étape suivante d'onboarding-interests, sinon 'app').
  const effectiveNextStep =
    user?.nextStep === 'verify-email' && !requireEmailVerification
      ? user.hasOnboardingInterests
        ? 'app'
        : 'onboarding-interests'
      : user?.nextStep;

  if (effectiveNextStep && effectiveNextStep !== 'app') {
    return <Navigate to={resolveNextStepUrl(effectiveNextStep)} replace />;
  }

  return children;
};

export default ProtectedRoute;
